import { Json } from "@/integrations/supabase/types";

export interface SubscriptionFeatures {
  currency_conversion: boolean;
  multiple_currencies: boolean;
  price_comparison: boolean;
  grouped_contracts: boolean;
  contract_services: boolean;
  reminders: boolean;
  payment_type_selection: boolean;
  dashboard: boolean;
  contract_pdf_email: boolean;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  plan_type: "free" | "basic" | "premium" | "enterprise";
  monthly_price: number;
  annual_price: number;
  features: SubscriptionFeatures;
  is_active: boolean;
  show_on_landing: boolean;
  created_at: string;
  updated_at: string;
}

export type SubscriptionStatus = "active" | "canceled" | "expired" | "pending";

export interface UserSubscription {
  id: string;
  user_id: string;
  plan_id: string;
  plan?: SubscriptionPlan;
  status: SubscriptionStatus;
  current_period_start: string;
  current_period_end: string;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateSubscriptionData {
  plan_id: string;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  current_period_end: string;
}

export interface AssignSubscriptionData {
  user_id: string;
  plan_id: string;
  current_period_start: string;
  current_period_end: string;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
}

// Helper function to convert database response to SubscriptionPlan
export const mapDbPlanToSubscriptionPlan = (data: any): SubscriptionPlan => {
  return {
    id: data.id,
    name: data.name,
    description: data.description || '',
    plan_type: data.plan_type,
    monthly_price: data.monthly_price,
    annual_price: data.annual_price || 0,
    features: data.features as unknown as SubscriptionFeatures,
    is_active: data.is_active,
    show_on_landing: Boolean(data.show_on_landing),
    created_at: data.created_at,
    updated_at: data.updated_at
  };
};
